import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">吃瓜热评</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentsData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-5 border border-background-200/60 hover:border-secondary-200/60 transition-colors duration-200"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                      {item.name}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                  </div>
                  <span className="inline-block mt-1 px-2 py-0.5 text-[11px] bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                    {item.topic}
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1 cursor-pointer hover:text-accent-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes.toLocaleString()}
                </span>
                <span className="cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line mr-1"></i>回复
                </span>
                <span className="cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-share-forward-line mr-1"></i>分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}